<template>
    <div class="components-container">
        <!-- 列表区域 -->
        <el-table :data="tableData" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="课程名称" prop="courseName" align="center"></el-table-column>
            <el-table-column label="开课部门" prop="deptName" width="180px" align="center"></el-table-column>
            <el-table-column label="学分" prop="credit" width="50px" align="center"></el-table-column>
            <el-table-column label="总学时" prop="totalHour" width="70px" align="center"></el-table-column>
            <el-table-column label="理论学时" prop="theoryHour" width="50px" align="center"></el-table-column>
            <el-table-column label="实践学时" prop="trainingHour" width="50px" align="center"></el-table-column>
            <el-table-column label="修读学期" prop="semesterNum" :formatter="semesterNumFormatter" width="80px" align="center"></el-table-column>
            <el-table-column label="修读学时" prop="semesterLearnHour" width="50px" align="center"></el-table-column>
            <el-table-column label="考核方式" prop="examTypeName" width="50px" align="center"></el-table-column>
        </el-table>
        <div style="margin-top:20px; float:right;">
            <el-button type="primary" @click="importCourse">导入</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        props: ['listHeight'],
        data() {
            return {
                //查询列表数据
                queryForm: {
                    year: null,
                    majorCode: null,
                    courseType: null,
                },
                semesterNumName: ["第一学期", "第二学期", "第三学期", "第四学期", "第五学期", "第六学期", "第七学期", "第八学期", "第九学期", "第十学期"],
                //表数据
                tableData: [],
                tableLoading: true,
                mainTableHeight: 500,
                loadingMask: null,
            }
        },
        mounted() {
            this.queCourseList();

            this.$nextTick().then(() => {
                if(this.listHeight){
                    this.mainTableHeight = this.listHeight;
                }else{
                    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                    //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                    this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                    // 监听窗口大小变化
                    let self = this;
                    window.onresize = function() {
                        self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                    };
                }
            });
        },
        methods: {
            queCourseList() {
                this.tableLoading = true;

                this.$api.teachingManage.coursePreConfig.queCourseList({
                    data: this.queryForm,
                }).then((res) => {
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;

                    this.$refs.mainTable.toggleAllSelection();
                }).catch((error) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            semesterNumFormatter(row) {
                return this.semesterNumName[parseInt(row.semesterNum)-1];
            },
            importCourse(){
                //获取导入课程信息
                let selCourses = this.$refs.mainTable.selection;
                if(selCourses.length === 0){
                    this.$alert('请至少选择一门课程', '提示', {
                        confirmButtonText: '确定',
                    });
                    return;
                }

                let idArray = new Array();
                for(let i=0; i<selCourses.length; i++){
                    idArray.push(selCourses[i].id);
                }

                this.$api.teachingManage.teachingScheme.importCourse({
                    data: {
                        year: this.queryForm.year,
                        majorCode: this.queryForm.majorCode,
                        preCourseIds: idArray.toString(),
                    }
                }).then((res) => {
                    let state = res.data.data.state;
                    switch (state) {
                        case 'success':
                            showNotify('成功', '导入成功', 'success', 1500);
                            this.$emit("refreshInfo");
                            break;
                        default:
                            showNotify('错误', '导入失败', 'error', 3000);
                            break;
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            closeDialog(){
                this.$emit("closeImportPubCourseDialog");
            },
        }
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// courseImport.vue?71da7a2c